module.exports = __webpack_public_path__ + "static/img/personal_bg.72c607f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/geren/personal_bg.png
// module id = Hr1/
// module chunks = 1